import i18n from 'shared/lib/i18n';

import { formatDate, formatRole, toSentenceCase } from '../../utils';
import { getRoleName } from '../Person/utils';

export const getAnnouncementCriteria = (announcement) => {
  const {
    buildings,
    roles,
    cameraSystem,
    accessControlSystem,
    startLaunchTime,
    endLaunchTime,
  } = announcement;
  const criteria = [];

  const dateFormat = 'MM.DD.YYYY';
  const startLaunch =
    startLaunchTime && formatDate(startLaunchTime, true, dateFormat);
  const endLaunch =
    endLaunchTime && formatDate(endLaunchTime, true, dateFormat);

  if (buildings?.length) {
    const buildingNames = buildings.map(({ name }) => name);
    const count = buildingNames?.length;
    const displayedBuildingsNames = buildingNames.splice(0, 2).join(', ');
    const othersCount = count && count - 2;
    let properties = `${i18n.t(
      'title.properties',
    )}: ${displayedBuildingsNames}`;
    if (othersCount && othersCount > 0) {
      properties += ` ${i18n.t('announcements.andOthers', {
        othersCount,
      })}`;
    }
    criteria.push(properties);
  }
  if (roles?.length) {
    const rolesNames = roles
      .map((roleId) => formatRole(getRoleName(roleId)))
      .join(', ');
    criteria.push(`${i18n.t('title.roles')}: ${rolesNames}`);
  }
  if (cameraSystem) {
    criteria.push(
      `${i18n.t('announcements.cameraSystems')}: ${toSentenceCase(
        cameraSystem,
      )}`,
    );
  }
  if (accessControlSystem) {
    criteria.push(
      `${i18n.t('title.accessControlSystem')}: ${toSentenceCase(
        accessControlSystem,
      )}`,
    );
  }
  if (startLaunch && endLaunch) {
    criteria.push(
      i18n.t('announcements.launchedBetween', { startLaunch, endLaunch }),
    );
  } else if (startLaunch) {
    criteria.push(i18n.t('announcements.launchedSince', { startLaunch }));
  } else if (endLaunch) {
    criteria.push(i18n.t('announcements.launchedBefore', { endLaunch }));
  }
  return criteria.join('\n');
};
